import React from "react";

const VARIANTS = {
  primary:
    "bg-brand-600 text-white hover:bg-brand-700 shadow-[0_1px_2px_rgba(0,0,0,0.08)] active:scale-[0.98]",
  secondary:
    "bg-white text-ink-800 border border-ink-200 hover:bg-ink-50 active:scale-[0.98]",
  ghost: "text-ink-700 hover:bg-ink-100 active:scale-[0.98]",
  outline:
    "bg-transparent text-brand-600 border-2 border-brand-600 hover:bg-brand-50 active:scale-[0.98]",
  dark: "bg-ink-900 text-white hover:bg-ink-800 active:scale-[0.98]",
};

const SIZES = {
  sm: "px-3.5 py-2 text-sm rounded-lg gap-1.5",
  md: "px-5 py-2.5 text-sm rounded-xl gap-2",
  lg: "px-6 py-3.5 text-base rounded-xl gap-2",
};

export default function Button({
  variant = "primary",
  size = "md",
  className = "",
  icon,
  iconRight,
  loading = false,
  children,
  ...props
}) {
  return (
    <button
      className={`inline-flex items-center justify-center font-semibold transition-all duration-150 disabled:opacity-50 disabled:pointer-events-none whitespace-nowrap ${VARIANTS[variant]} ${SIZES[size]} ${className}`}
      disabled={loading || props.disabled}
      {...props}
    >
      {loading ? (
        <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24" fill="none">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
        </svg>
      ) : (
        <>
          {icon}
          {children}
          {iconRight}
        </>
      )}
    </button>
  );
}
